import { Component, OnInit } from '@angular/core';

import { ScreenModeService } from 'ib/internetbank-core/ib-services/screen-mode.service';

@Component({
	selector: 'app-outside-layout',
	templateUrl: './outside-layout.component.html',
	styleUrls: ['./outside-layout.component.less'],
	standalone: false,
})
export class OutsideLayoutComponent implements OnInit {

	public isStandalone = ScreenModeService.isStandalone();

	constructor() { }

	public ngOnInit(): void {
	}

}
